import React from 'react'
import { TiArrowBack } from "react-icons/ti";
import { useNavigate } from "react-router-dom";


function BackButton({ link, text }) {
    const navigate = useNavigate();

    return (
        <div
            className="back-container"
            onClick={() => navigate({ link })}
        >
            <TiArrowBack size={20} />
            <span>{text}</span>
        </div>
    )
}

export default BackButton